import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { TooltipV2Root as TooltipRoot } from 'taboola-ultimate-ui';
import { resetStateToInitial } from 'actions';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { AppShape } from '../../../../AppShape';
import { NavigationSideBar } from '../../../../components/NavigationSideBar/NavigationSideBar';
import GenericError from '../GenericError/GenericError';
import styles from './errorPage.module.scss';

const EMPTY_APP_CONFIG = { legal: [], routingMap: {}, externalApps: [] };

export const ErrorPage = ({ config }) => {
    const { legal } = config;
    const dispatch = useDispatch();

    // Do reset on unmount
    useEffect(
        () => () => {
            dispatch(resetStateToInitial());
        },
        [dispatch]
    );

    return (
        <TooltipRoot className={styles['error-container']}>
            <AppShape
                config={config}
                sideBar={<NavigationSideBar config={{ ...EMPTY_APP_CONFIG, legal }} onlyLogout />}
            >
                <GenericError
                    heading={<FormattedMessage id="errorPage.heading" />}
                    message={<FormattedMessage id="errorPage.message" />}
                />
            </AppShape>
        </TooltipRoot>
    );
};

ErrorPage.propTypes = { config: PropTypes.object };
